import React from 'react';

export default function AuthLayout({ children }) {
  return (
    <div className="min-h-screen flex">
      {/* Left side - Image */}
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden bg-slate-900">
        <img
          src="https://images.unsplash.com/photo-1636142466028-8c6c7cd616b7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjb3Jwb3JhdGUlMjBvZmZpY2UlMjBidWlsZGluZyUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3NjgwNTAwMTN8MA&ixlib=rb-4.1.0&q=85"
          alt="Modern corporate building"
          className="absolute inset-0 w-full h-full object-cover opacity-70"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 to-transparent" />
        <div className="relative z-10 flex flex-col justify-end p-12 text-white">
          <h1 className="text-4xl font-bold mb-4 font-heading">MyTour</h1>
          <p className="text-xl text-slate-200 mb-2">BBEST REALTY</p>
          <p className="text-slate-300 max-w-md">
            Streamlining expense reimbursements for our marketing team. 
            Submit claims, track approvals, and get reimbursed faster.
          </p>
        </div>
      </div>

      {/* Right side - Form */}
      <div className="flex-1 flex items-center justify-center p-8 bg-slate-50">
        <div className="w-full max-w-md">
          {/* Mobile logo */}
          <div className="lg:hidden text-center mb-8">
            <h1 className="text-3xl font-bold text-slate-900 font-heading">MyTour</h1>
            <p className="text-slate-600">BBEST REALTY</p>
          </div>
          
          {children}
        </div>
      </div>
    </div>
  );
}
